import React from 'react';
import { Button, ButtonColor } from 'ui-builder';
import { EmailProvider } from 'nekst-api';

interface EmailErrorStatusProps {
  message: string;
  provider?: EmailProvider | null;
  onRetry: () => void;
  onReturnToSettings: () => void;
}

export default function EmailErrorStatus({
  message,
  provider,
  onRetry,
  onReturnToSettings
}: EmailErrorStatusProps) {
  const getProviderName = () => {
    switch (provider) {
      case EmailProvider.GMAIL:
        return 'Gmail';
      default:
        return 'Email';
    }
  };

  return (
    <div>
      <i
        className="fa fa-exclamation-circle"
        style={{ fontSize: '2rem', marginBottom: '1rem', color: '#dc3545' }}
      />
      <h2 style={{ marginBottom: '1rem', color: '#dc3545' }}>
        Failed to connect {getProviderName()} account
      </h2>
      <p style={{ color: '#666', marginBottom: '2rem' }}>
        {message}
      </p>
      <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
        <Button
          text="Try Again"
          color={ButtonColor.GREEN}
          onClick={onRetry}
        />
        <Button
          text="Return to Settings"
          color={ButtonColor.GRAY}
          onClick={onReturnToSettings}
        />
      </div>
    </div>
  );
}